import {Box, Button, Stack, Typography} from '@mui/material';
import {MotorV2Enums, OdontoBookingTaggingEnum} from 'main/analytics/gaTagsEnum';
import {AlertModal, DataInfo} from 'presentation/components';
import {Loading} from 'presentation/components/Loading/Loading';
import {AuthorizationsEnum} from 'presentation/constants';
import {translations} from 'presentation/translations-new';
import React, {Fragment} from 'react';
import {OdontoConfirmBookingModalsProps} from './types';
import {useOdontoConfirmBookingModals} from '../../hooks/useOdontoConfirmBookingModals';

const {
	unavailableSchedule,
	unauthorizedError,
	successBookingDescription,
	successBookingHeaderTitle,
	successBookingAlert,
	confirmationBooking,
	errorBookingTitle,
} = translations['pt-br'].privateFlow.bookingFlow;
const {agreementText, pleaseTryAgain} = translations['pt-br'].commons;
const {appointmentProtocol} =
	translations['pt-br'].privateFlow.myAppointments.myAppointmentDetails.appointmentInstructions;

export function OdontoConfirmBookingModals({
	isUnauthorized,
	isDone,
	hasHourOrAvailabilityError,
	isGenericError,
	setBookingState,
	handleBack,
}: OdontoConfirmBookingModalsProps) {
	const {
		handleCallChatRoom,
		handleCloseErrorDialogState,
		handleCloseBackToProfissionalSelection,
		handleCloseSuccessDialogState,
		dataTagIdSuccess,
		alertModalpaperStyles,
		protocolNumber,
		callChatRoomIsLoading,
		navigate,
		isHideConfirmationBookingModalEnabled,
	} = useOdontoConfirmBookingModals({handleBack, setBookingState});

	return (
		<Fragment>
			<AlertModal
				slotProps={{
					paper: alertModalpaperStyles,
				}}
				description={pleaseTryAgain}
				headerTitle={confirmationBooking}
				title={errorBookingTitle}
				onClose={handleCloseErrorDialogState}
				open={isGenericError}
				variant="info"
			/>

			<AlertModal
				slotProps={{
					paper: alertModalpaperStyles,
				}}
				description={unavailableSchedule.description}
				headerTitle={unavailableSchedule.title}
				buttonLabel={unavailableSchedule.button}
				onClose={handleCloseBackToProfissionalSelection}
				open={hasHourOrAvailabilityError}
				variant="info"
			/>

			<AlertModal
				slotProps={{
					paper: alertModalpaperStyles,
				}}
				description={
					<Stack gap={2}>
						<Typography variant="body1" textAlign="center">
							{unauthorizedError.description1}
						</Typography>
						<Typography variant="body1" textAlign="center">
							{unauthorizedError.description2}
						</Typography>
					</Stack>
				}
				headerTitle={unauthorizedError.title}
				buttonLabel={unauthorizedError.button1}
				onClose={handleCloseErrorDialogState}
				open={isUnauthorized}
				variant="info"
				data-tag-id={MotorV2Enums.V2_MODAL_ERRO_GENERICO}
				footerContent={
					<Stack gap={1} width="100%">
						<Button
							onClick={() => navigate(AuthorizationsEnum.AUTHORIZATIONS)}
							variant="contained"
							size="large"
							fullWidth
							data-tag-id={MotorV2Enums.V2_CLICK_CTA_ERRO_GENERICO}>
							{unauthorizedError.button1}
						</Button>
						<Button
							onClick={handleCallChatRoom}
							variant="outlined"
							size="large"
							fullWidth
							data-tag-id={MotorV2Enums.V2_CLICK_CTA_ERRO_GENERICO}
							endIcon={
								callChatRoomIsLoading ? <Loading size={16} color="inherit" /> : null
							}
							disabled={callChatRoomIsLoading}>
							{unauthorizedError.button2}
						</Button>
					</Stack>
				}
			/>

			{isHideConfirmationBookingModalEnabled ? null : (
				<AlertModal
					slotProps={{
						paper: alertModalpaperStyles,
					}}
					subDescription={
						<Box alignSelf="center">
							<DataInfo
								primaryText={appointmentProtocol}
								secondaryText={protocolNumber}
								iconName="assignment-filled"
							/>
						</Box>
					}
					headerDataTagId={dataTagIdSuccess}
					buttonDataTagId={
						OdontoBookingTaggingEnum.CLICK_ENTENDI_MODAL_CONFIRMACAO_AGENDAMENTO
					}
					description={successBookingDescription}
					title={successBookingAlert}
					headerTitle={successBookingHeaderTitle}
					open={isDone}
					onClose={handleCloseSuccessDialogState}
					variant="success"
					buttonLabel={agreementText}
				/>
			)}
		</Fragment>
	);
}
